import CryptoJS from 'crypto-js';

export const parseToken = token => {
  if (!token) return null;
  // 分割 token 成三个部分：头部、有效载荷和签名
  const [header, payload, signature] = token.split('.');

  // 解码 Base64URL 编码的字符串为普通字符串
  const decodeBase64Url = str => {
    // Base64URL 和 Base64 之间的转换
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    // 补充 Base64 字符串的等号
    const padding = '='.repeat((4 - (base64.length % 4)) % 4);
    // 使用 CryptoJS 进行解码
    return CryptoJS.enc.Base64.parse(base64 + padding).toString(CryptoJS.enc.Utf8);
  };

  // 解析 JSON 字符串
  const parseJson = str => {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  };

  // 解码头部和有效载荷
  const decodedHeader = decodeBase64Url(header);
  const decodedPayload = decodeBase64Url(payload);

  // 解析 JSON 数据
  const parsedHeader = parseJson(decodedHeader);
  const parsedPayload = parseJson(decodedPayload);

  return {
    header: parsedHeader,
    payload: parsedPayload,
    signature,
  };
};
